import { useStatsigExperiment } from './use-statsig-experiment'

export const useStatsigExperimentGroupName = (experimentName) => {
  const experiment = useStatsigExperiment(experimentName)
  return experiment?.groupName || 'control'
}
